import React from "react";
import { FieldProps, useFormikContext } from "formik";
import { Box, Checkbox, CheckboxProps, Typography } from "@mui/material";
import theme from "../../theme";

interface Props {
  fontVariant: "caption" | "body2" | "h5";
  label: string;
  checked: boolean;
  onChange?: (checked: boolean) => void;
  tabIndex?: number;
  confidential?: boolean;
}

const FormikCheckbox: React.FC<FieldProps & CheckboxProps & Props> = (
  props
) => {
  const {
    fontVariant,
    label,
    checked,
    field,
    onChange,
    confidential,
    ...rest
  } = props;

  const { setFieldValue } = useFormikContext();

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    if (onChange) {
      onChange(checked);
    } else {
      setFieldValue(field.name, checked);
    }
  };

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Checkbox
          {...field}
          onChange={handleChange}
          checked={!!field.value}
          color={confidential ? "error" : "primary"}
          sx={{
            color: confidential
              ? theme.palette.error.main
              : theme.palette.primary.main,
            "&.Mui-checked": {
              outline: confidential
                ? theme.palette.error.main
                : theme.palette.primary.main,
            },
            "& .MuiSvgIcon-root": { fontSize: confidential ? 30 : "initial" },
            paddingLeft: 0,
          }}
          disableFocusRipple
          disableRipple
          tabIndex={props.tabIndex}
          {...rest}
        />
        <Typography
          variant={fontVariant ? fontVariant : "caption"}
          sx={{ textDecoration: confidential ? "underline" : undefined }}
        >
          {label}
        </Typography>
      </Box>
    </>
  );
};

export default FormikCheckbox;
